import * as Avatar from '@radix-ui/react-avatar'
import { PropsWithChildren } from 'react'
import styled from 'styled-components'

const Wrap = styled(Avatar.Root)`
  display: grid;
  place-content: center;
`

export interface AvatarComponentProps {
  src: string
  alt: string
}

function AvatarComponent({
  src,
  alt,
  ...props
}: PropsWithChildren<AvatarComponentProps>) {
  const initial = alt.substring(0, 2).toUpperCase() // first two letters

  return (
    <Wrap {...props}>
      <Avatar.Image src={src} alt={alt} />
      <Avatar.Fallback>{initial}</Avatar.Fallback>
    </Wrap>
  )
}

export default AvatarComponent
